<app-menu></app-menu>

<div class="container-fluid pt-3">    
    <div class="row">
        <div class="col-12 col-lg-9">
            <h1 class="titulo">Cadastro de contatos</h1>
            <h2 class="subtitulo">Crie, edite ou exclua contatos</h2>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-9">
            <app-button class="float-end" textButton="+ cadastrar" (click)="openModalAddContact()"></app-button>

            <div class="busca-contato">
                <mat-form-field>
                    <mat-label>Busca por contatos</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Informe CPF ou nome" #input>
                </mat-form-field>
            </div>

            <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="id">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                    <td class="td-table" mat-cell *matCellDef="let contact"> {{contact.id}} </td>
                </ng-container>
            
                <ng-container matColumnDef="name">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
                    <td class="td-table" mat-cell *matCellDef="let contact"> {{contact.name}} </td>
                </ng-container>
            
                <ng-container matColumnDef="email">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                    <td class="td-table" mat-cell *matCellDef="let contact"> {{contact.email}} </td>
                </ng-container>
            
                <ng-container matColumnDef="cpf">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> CPF </th>
                    <td class="td-table" mat-cell *matCellDef="let contact"> {{contact.cpf}} </td>
                </ng-container>

                <ng-container matColumnDef="phoneNumber">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> Telefone </th>
                    <td class="td-table" mat-cell *matCellDef="let contact"> {{contact.phoneNumber}} </td>
                </ng-container>

                <ng-container matColumnDef="cep">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> Cep </th>
                    <td class="td-table" mat-cell *matCellDef="let contact"> {{contact.cep}} </td>
                </ng-container>

                <ng-container matColumnDef="address">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> Endereço </th>
                    <td class="td-table" mat-cell *matCellDef="let contact"> {{contact.address}} </td>
                </ng-container>

                <ng-container matColumnDef="complement">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> Complemento </th>
                    <td class="td-table" mat-cell *matCellDef="let contact"> {{contact.complement}} </td>
                </ng-container>

                <ng-container matColumnDef="city">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> Cidade </th>
                    <td class="td-table" mat-cell *matCellDef="let contact"> {{contact.city}} </td>
                </ng-container>

                <ng-container matColumnDef="uf">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> UF </th>
                    <td mat-cell *matCellDef="let contact"> {{contact.uf}} </td>
                </ng-container>

                <ng-container matColumnDef="geographicalPosition">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header> Position </th>
                    <td mat-cell *matCellDef="let contact"> {{contact.geographicalPosition}} </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th class="th-table" mat-header-cell *matHeaderCellDef mat-sort-header></th>
                    <td class="td-table" mat-cell *matCellDef="let contact">
                        <mat-icon class="icone-tabela" (click)="openModalEditContact(contact)">edit</mat-icon>
                        <mat-icon class="icone-tabela" (click)="deleteContact(contact.id)">delete</mat-icon>
                    </td>
                </ng-container>
            
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let contact; columns: displayedColumns;"></tr>
            
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell no-data" colspan="4">Nenhum registro encontrado "{{input.value}}"</td>
                </tr>
            </table>            
            <mat-paginator class="shadow-sm" [pageSizeOptions]="[3, 5, 7, 10]" aria-label="Selecione número páginas"></mat-paginator>
        </div>
    </div>
</div>
